export function formatTel(telefone: string): string | null {
  if (telefone) {
    telefone = telefone.replace(/\D/g, '');
    if (telefone === '' || telefone.length < 2) {
      return telefone;
    }
    return telefone.replace(/^(\d{0,2})(\d{0,5})(\d{0,4})$/, '($1) $2-$3');
  }
  return null;
}

export function formatCpf(cpf: string | null): string | null {
  if (cpf && cpf.length === 11) {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  return null;
}

export function formatDate(data: Date | string): any {
  if (data) {
    const dataFormatada = new Date(data).toLocaleString('pt-br');
    return dataFormatada.toString().replace(',', ' ');
  }
  return null;
}

export function getFuncionarioId() {
  const funcionario = JSON.parse(localStorage.getItem('Funcionario') ?? '');
  if (funcionario) {
    return funcionario.IdFuncionario;
  }
  return;
}

export function formatDateForInput(dateString: string): string {
  const date = new Date(dateString);
  const localOffset = date.getTimezoneOffset() * 60000;
  const localDate = new Date(date.getTime() - localOffset);
  const dateYear = localDate.getFullYear();
  if (dateYear < 2000) {
    return '';
  }
  return localDate.toISOString().slice(0, 16);
}

export function formatDateForInput2(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = ('0' + date.getDate()).slice(-2);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
